import React, { useEffect, useState } from "react";
import classes from "./LandingPage.module.css";
import { motion } from "framer-motion";
import LinedSection from "../component/LinedSection";
import { FaArrowRight, FaStar, FaWhatsapp } from "react-icons/fa6";
import { fetchGamesApi } from "../http/http";
import { useNavigate } from "react-router-dom";
import AllGamesModal from "../component/AllGamesModal";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const LandingPage = () => {

    const [allGames, setAllGames] = useState([]);
    const [modal, setModal] = useState(false);
    const [popularGames, setPopularGames] = useState([]);
    const [loading, setLoading] = useState(true);

    const selectedLanguageId = Number(
        useSelector((state) => state?.persisted?.languageSlice?.language ?? 1)
    );

    const { t } = useTranslation();

    const navigate = useNavigate();

    const pickRandomK = (arr, k = 20) => {
        const n = Array.isArray(arr) ? arr.length : 0;
        if (n <= k) return arr ? [...arr] : [];

        const idx = new Set();
        while (idx.size < k) {
            idx.add(Math.floor(Math.random() * n));
        }
        return Array.from(idx, (i) => arr[i]);
    };

    const fetchGames = async (language) => {
        try {
            setLoading(true);
            const response = await fetchGamesApi(language);
            console.log(response, 'response--');
            setAllGames(response?.data?.games);
            setPopularGames(pickRandomK(response?.data?.games, 4));
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error, 'error--');
        }
    }

    console.log(popularGames, 'pg');

    useEffect(() => {
        fetchGames(selectedLanguageId);
    }, [selectedLanguageId]);

    return (
        <main className={classes.main}>

            <motion.div
                className={classes.container}
                initial={{
                    backgroundImage:
                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                }}
                animate={{
                    backgroundImage: [
                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #0a58b7)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #ff5424)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #0f5cec)",
                    ],
                }}
                transition={{
                    duration: 7,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                }}
            >

                {/* subtle glow background */}
                <div className={classes.glowLayer} />

                <LinedSection />

                <section className={classes.shell}>

                    {/* TOP HEADER */}
                    <section className={classes.hero_container}>
                        <header className={classes.topBar}>
                            <div className={classes.brand}>
                                <div className={classes.brand_container}>
                                    <img src="/images/logo2.png" alt="uv gaming" className={classes.uv_logo} />
                                    <div className={classes.brandSub}>Powered by Vodacom</div>
                                </div>
                            </div>

                            <div className={classes.topActions}>
                                <button className={classes.btnGhost} onClick={() => navigate("/login")}>{t("1")}</button>
                                <button className={classes.btnPrimary} onClick={() => navigate("/subscribe")}>{t("2")}</button>
                            </div>
                        </header>
                    </section>


                    {/* HERO */}
                    <section className={classes.hero_container}>

                        <div className={classes.red_swoosh_container}>
                            <img src="/images/red-swoosh.png" alt="red swoosh" className={classes.red_swoosh_img} />
                        </div>

                        <section className={classes.hero}>

                            <div className={classes.heroLeft}>
                                <h1 className={classes.heroTitle}>
                                    {t("3")} <br />
                                    <span>{t("4")}</span>
                                </h1>

                                <div className={classes.pricePill}
                                    onClick={() => navigate("/subscribe")}
                                >
                                    {t("5")} <b>{t("6")}</b> {t("7")}
                                </div>

                                <div className={classes.heroChips}>
                                    <div className={classes.chip}>
                                        <img src="/images/android.png" alt="android" className={classes.android_icon} />
                                        {t("8")}</div>
                                    <div className={classes.chip}>
                                        <img src="/images/wallet2.png" alt="wallet" className={classes.android_icon} />
                                        {t("9")} <b>
                                            {t('10')}
                                        </b>
                                        {t("11")}
                                        <img src="/images/m-pesa.png" alt="m-pesa" className={classes.mpesa_in_chip} />
                                    </div>
                                </div>
                            </div>

                            <div className={classes.heroRight}>
                                <img src="/images/hero-image8.png" alt="Hero" className={classes.heroImage} />
                            </div>


                        </section>
                    </section>

                    {/* PLANS + HOW */}
                    <section className={classes.hero_container}>
                        <section className={classes.midGrid}>


                            <motion.div className={classes.cardSection}
                                initial={{
                                    backgroundImage:
                                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                                }}
                                animate={{
                                    backgroundImage: [
                                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                                        "radial-gradient(820% 320% at 50% 25%, #000, #ff0000)",
                                        "radial-gradient(820% 320% at 50% 25%, #000, #20b000)",
                                        "radial-gradient(820% 320% at 50% 25%, #000, #610000)",
                                    ],
                                }}
                                transition={{
                                    duration: 7,
                                    ease: "easeInOut",
                                    repeat: Infinity,
                                    repeatType: "mirror",
                                }}
                            >

                                <div className={classes.cardSectionBg}></div>

                                {/* <Lottie animationData={gridAnimation} loop autoPlay className={classes.animation_grid} /> */}
                                <h4 className={classes.sectionTitle}>{t("12")}</h4>

                                <div className={classes.planGrid}>
                                    <div className={classes.planCard}
                                        onClick={() => navigate("/subscribe")}

                                    >
                                        <div className={classes.planName}>{t("13")}</div>
                                        <div className={classes.planPrice}>
                                            <span>3</span>MT
                                        </div>
                                        <div className={classes.planFeature}>
                                            <img src="/images/game-controller.png" alt="game" className={classes.planIcon} />
                                            {t("14")}</div>
                                        <button className={classes.planBtn}>{t("2")}</button>
                                    </div>

                                    <div className={`${classes.planCard} ${classes.popular}`}
                                        onClick={() => navigate("/subscribe")}

                                    >
                                        <div className={classes.badge}>{t("15")}</div>
                                        <div className={classes.planName}>{t("16")}</div>
                                        <div className={classes.planPrice}>
                                            <span>20</span>MT
                                        </div>
                                        <div className={classes.planFeature}>
                                            <img src="/images/schedule.png" alt="game" className={classes.planIcon} />
                                            {t("17")}</div>
                                        <button className={classes.planBtn}>{t("2")}</button>
                                    </div>

                                    <div className={classes.planCard}
                                        onClick={() => navigate("/subscribe")}

                                    >
                                        {/* <div className={classes.badgeAlt}>Melhor Valor</div> */}
                                        <div className={classes.planName}>{t("18")}</div>
                                        <div className={classes.planPrice}>
                                            <span>50</span>MT
                                        </div>
                                        <div className={classes.planFeature}>
                                            <img src="/images/calendar.png" alt="game" className={classes.planIcon} />
                                            {t("19")}</div>
                                        <button className={classes.planBtn}>{t("2")}</button>
                                    </div>
                                </div>

                            </motion.div>

                            <aside className={classes.howCard}>
                                <div className={classes.howTitle}>{t("20")}</div>

                                <div className={classes.steps}>
                                    <div className={classes.step}>
                                        <div className={classes.stepNum}>1</div>
                                        <div className={classes.stepText}>{t("21")}</div>
                                    </div>
                                    <div className={classes.step}>
                                        <div className={classes.stepNum}>2</div>
                                        <div className={classes.stepText}>{t("22")}</div>
                                    </div>
                                    <div className={classes.step}>
                                        <div className={classes.stepNum}>3</div>
                                        <div className={classes.stepText}>{t("23")}</div>
                                    </div>
                                </div>

                                <button className={classes.activateBtn}
                                    onClick={() => navigate("/subscribe")}

                                >
                                    {t("24")} <span className={classes.arrow}><FaArrowRight /></span>
                                </button>
                            </aside>
                        </section>
                    </section>

                    <section className={classes.shell}>

                        {/* FEATURED GAMES */}
                        <section className={classes.hero_container}>
                            <section className={classes.featuredWrap}>
                                <div className={classes.featuredHead}>
                                    <div className={classes.sectionTitleSmall}>{t("25")}</div>
                                    <button
                                        disabled={loading}
                                        className={classes.linkBtn}
                                        onClick={() => setModal(true)}
                                    >{t("26")}</button>
                                </div>

                                <div className={classes.gamesRow}>
                                    {
                                        loading ?
                                            Array.from({ length: 4 })?.map((_, idx) => {
                                                return (
                                                    <div className={classes.gameCard} key={idx}>
                                                        <div className={classes.gameImage} ></div>
                                                        <div className={classes.gameLabel}>
                                                            {/* <p className={classes.gameText}></p> */}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            popularGames?.map((d, idx) => {
                                                return (
                                                    <div className={classes.gameCard} key={idx}>
                                                        <img src={d?.game_banner} alt={d?.game_name} className={classes.gameImage} />
                                                        <div className={classes.gameLabel}>
                                                            <p className={classes.gameText}>{d?.game_name}</p></div>
                                                    </div>
                                                )
                                            })}

                                    {/* <div className={`${classes.gameCard}`}>
                                        <img src="../images/feature-bg.png" alt="game" className={classes.gameImage} />
                                        <div className={classes.gameLabel}>
                                            <p className={classes.gameText}>

                                                Battle Arena</p></div>
                                    </div>

                                    <div className={classes.gameCard}>
                                        <img src="../images/feature-bg.png" alt="game" className={classes.gameImage} />
                                        <div className={classes.gameLabel}>
                                            <p className={classes.gameText}>
                                                Futebol Pro
                                            </p>
                                        </div>
                                    </div>

                                    <div className={classes.gameCard}>
                                        <img src="../images/feature-bg.png" alt="game" className={classes.gameImage} />
                                        <div className={classes.gameLabel}>
                                            <p className={classes.gameText}>
                                                Aventura
                                            </p>
                                        </div>
                                    </div> */}
                                </div>
                            </section>
                        </section>


                        {/* PAYMENT + APP */}
                        <section className={classes.hero_container}>
                            <section className={classes.bottomGrid}>
                                <div className={classes.paymentCard}>
                                    <div className={classes.cardTitle}>
                                        <span className={classes.iconDot} /> {t("27")}
                                    </div>

                                    <div className={classes.logoGrid}>
                                        <div className={classes.paymentMethod}>
                                            <img src="/images/vodacom-logo.png" alt="vodacom" className={classes.paymentMethodLogo} />
                                        </div>
                                        <div className={classes.paymentMethod}>
                                            <img src="/images/m-pesa.png" alt="vodacom" className={classes.paymentMethodLogo} />
                                        </div>
                                    </div>

                                    <div className={classes.safeText}>{t("28")}</div>
                                </div>

                                <div className={classes.appCard}>
                                    <div className={classes.appLeft}>

                                        <div className={classes.cardTitle}>
                                            <span className={classes.iconDot} /> {t("29")}
                                        </div>

                                        <button className={classes.downloadBtn}>{t("30")}</button>

                                        <div className={classes.ratingRow}>
                                            <div className={classes.ratingValue}>4.8</div>
                                            <div className={classes.stars}>
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                                <FaStar className={classes.star} />
                                            </div>
                                        </div>
                                    </div>

                                    <img src="/images/android2.png" alt="android" className={classes.phoneMock} />
                                </div>
                            </section>
                        </section>



                        {/* FOOT CHIPS */}
                        <section className={classes.hero_container}>
                            <footer className={classes.footerChips}>
                                <div className={classes.footChip}>
                                    <FaWhatsapp className={classes.whatsapp_icon} />
                                    <span className={classes.footChip_paragraph}>
                                        {t("31")}
                                    </span>
                                </div>
                                <div className={classes.footChip}>{t("32")}</div>
                            </footer>
                        </section>

                    </section>

                </section>
            </motion.div>

            <AllGamesModal games={allGames} modal={modal} setModal={setModal} />
        </main>
    );
};

export default LandingPage;